<!--
  - Copyright (c) 2023. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <api-keys-table :subject="user._id" type="user" />
</template>

<script>
import ApiKeysTable from '@/components/api-key/ApiKeysTable.vue';

export default {
    name: 'UserApiKeyTab',
    components: { ApiKeysTable },
    props: ['user']
};
</script>

<style scoped></style>
